export default __webpack_public_path__ + "static/media/OSMOS_CENERE_MATT_120X120_04.927076a4.jpg";